import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function SpotlightImage({ src, alt, className = "", parallax = true, caption }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], parallax ? [-40, 40] : [0, 0]);

  return (
    <figure ref={ref} className={`relative overflow-hidden group ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y }}
        className="w-full h-full object-cover grayscale-[35%] contrast-[1.02] group-hover:grayscale-0 transition-[filter] duration-700"
      />
      <div className="absolute inset-0 pointer-events-none ring-1 ring-black/10" />
      {caption && (
        <figcaption className="absolute bottom-3 left-3 font-mono text-[10px] tracking-[0.2em] uppercase text-white/90 mix-blend-difference">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
